import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonVariant } from "components/base/Button";
import ModalCriarConta from "./ModalCriarConta";

interface BotaoCriarContaProps {
    size?: "sm" | "lg";
    variant?: ButtonVariant;
    className?: string;
    children?: React.ReactNode;
}

const BotaoCriarConta: React.FC<BotaoCriarContaProps> = ({
    size,
    variant = "primary",
    className = "",
    children
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                onClick={handleClick}
                className={`d-flex align-items-center ${className}`}
            >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                {children || 'Criar Conta'}
            </Button>

            <ModalCriarConta
                show={showModal}
                onHide={handleClose}
            />
        </>
    );
};

export default BotaoCriarConta; 